(() => {
  const modules = document.querySelectorAll('.workflow-module');
  if (!modules.length) return;

  const BREAKPOINT_MD = 768;

  // -----------------------------
  // Utilities
  // -----------------------------

  const isMobile = () => window.innerWidth < BREAKPOINT_MD;

  const getGap = () => (isMobile() ? 80 : 128);
  const getPinStep = () => (isMobile() ? 76 : 92);
  const getPinOffset = () => (isMobile() ? 112 : 150);

  const getPageTop = (el) => el.getBoundingClientRect().top + window.scrollY;

  // -----------------------------
  // Module Init
  // -----------------------------

  const initModule = (module) => {
    const body = module.querySelector('.workflow-module__body');
    const items = module.querySelectorAll('.workflow-module__item');
    const cards = module.querySelectorAll('.workflow-card');
    const pins = module.querySelectorAll('.workflow-module__pin');

    if (!body || !cards.length) return;

    let controller;
    let scenes = [];

    // -----------------------------
    // Layout
    // -----------------------------

    const layout = () => {
      let offset = 0;
      const GAP = getGap();

      cards.forEach((card, i) => {
        const item = items[i];
        if (!item) return;

        item.style.top = `${offset}px`;

        const rect = card.getBoundingClientRect();
        const margin = parseFloat(getComputedStyle(card).marginTop) + parseFloat(getComputedStyle(card).marginBottom);

        offset += rect.height + margin + GAP;
      });

      body.style.setProperty('--cards-total-height', `${offset - GAP}px`);
    };

    const safeLayout = debounce(layout, 16);

    // Single ResizeObserver per module
    const ro = new ResizeObserver(safeLayout);
    cards.forEach((card) => ro.observe(card));

    window.addEventListener('resize', safeLayout);

    layout();

    // Store ref for cleanup
    module._resizeObserver = ro;

    // -----------------------------
    // ScrollMagic
    // -----------------------------

    const destroyScenes = () => {
      scenes.forEach((scene) => scene.destroy(true));
      scenes = [];
      if (controller) controller.destroy(true);
    };

    const buildScenes = () => {
      destroyScenes();

      controller = new ScrollMagic.Controller();

      const lastIndex = cards.length - 1;
      const lastStart = getPageTop(cards[lastIndex]);

      const pinStep = getPinStep();
      const lastOffset = lastIndex * pinStep;
      const PIN_OFFSET = getPinOffset();

      cards.forEach((card, index) => {
        if (index === lastIndex) return;
        if (!pins[index]) return;

        const start = getPageTop(card);
        const offset = index * pinStep;
        const duration = Math.max(lastStart - start + (offset - lastOffset), 0);

        const scene = new ScrollMagic.Scene({
          triggerElement: pins[index],
          triggerHook: 0,
          offset: -PIN_OFFSET,
          duration,
        })
          .setPin(card)
          .addTo(controller);

        scenes.push(scene);
      });
    };

    const safeBuildScenes = debounce(buildScenes, 50);

    window.addEventListener('load', buildScenes);
    window.addEventListener('resize', safeBuildScenes);
  };

  modules.forEach(initModule);
})();
